/**
 * Abre el menú de navegación mobile
 * @param {HTMLElement} navContainer
 * @param {HTMLElement} nav
 */
function openMobileMenu(navContainer, nav) {
  const body = document.body;
  body.classList.add('overflow-hidden');
  nav.classList.add('translate-x-0');
  navContainer.classList.add('bg-black', 'pointer-events-auto');
  nav.classList.remove('translate-x-full');
  navContainer.classList.remove('bg-transparent', 'pointer-events-none');
}

/**
 * Cierra el menú de navegación mobile
 * @param {HTMLElement} navContainer
 * @param {HTMLElement} nav
 */
function closeMobileMenu(navContainer, nav) {
  const body = document.body;
  body.classList.remove('overflow-hidden');
  nav.classList.remove('translate-x-0');
  navContainer.classList.remove('bg-black', 'translate-x-0', 'pointer-events-auto');
  nav.classList.add('translate-x-full');
  navContainer.classList.add('bg-transparent', 'pointer-events-none');
}

document.addEventListener('DOMContentLoaded', function () {
  const openMenuElements = document.querySelectorAll('.open-menu__action');
  const closeMenuElements = document.querySelectorAll('.close-menu__action');
  const mobileNavigationContainerElement = document.querySelector('#mobile-navigation');
  const mobileNavigationElement = mobileNavigationContainerElement.querySelector('nav');

  openMenuElements.forEach((item) => {
    item.addEventListener('click', function () {
      openMobileMenu(mobileNavigationContainerElement, mobileNavigationElement);
    });
  });

  closeMenuElements.forEach((item) => {
    item.addEventListener('click', function () {
      closeMobileMenu(mobileNavigationContainerElement, mobileNavigationElement);
    });
  });
});

/**
 * Swipper Configuration
 */
var swiper = new Swiper('.swiper', {
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

let totalGeneralIsn = 0;
let totalModalidadAIsn = 0;
let totalModalidadBIsn = 0;
let totalModalidadCIsn = 0;

let totalModAElement;
let totalModalidadAElement;
let totalModBElement;
let totalModalidadBElement;
let totalModalidadCElement;
let totalModCElement;

const contadores = {
  1: 0,
  2: 0,
  3: 0,
};

function handleFormSubmit(modalidad) {
  const fields = {
    employ: 'employ' + modalidad,
    salary: 'salary' + modalidad,
    weeks: 'weeks' + modalidad,
    salaryMin: 'salaryMin' + modalidad,
  };
  /* empty inputs  */
  let deleteValue = () => {
    for (const key in fields) {
      if (fields.hasOwnProperty(key) && key !== 'salaryMin') {
        document.getElementById(fields[key]).value = '';
      }
    }
  };
  /* take value inputs */
  const processData = (fields) => {
    const data = {};
    for (const key in fields) {
      if (fields.hasOwnProperty(key)) {
        data[key] = parseFloat(document.getElementById(fields[key]).value);
      }
    }
    return data;
  };

  const formulario = document.getElementById('content' + modalidad);
  const idNumero = formulario.id.match(/\d+/)[0];
  const cardResult = document.getElementById('result' + modalidad);

  totalGeneralElement = document.getElementById('totalGeneral');
  totalModalidadAElement = document.getElementById('totalModalidadA');
  totalModAElement = document.getElementById('totalModA');

  totalModalidadBElement = document.getElementById('totalModalidadB');
  totalModBElement = document.getElementById('totalModB');

  totalModalidadCElement = document.getElementById('totalModalidadC');
  totalModCElement = document.getElementById('totalModC');

  const deleteBtnA = document.getElementById('deleteCardOne');
  const deleteBtnB = document.getElementById('deleteCardTwo');
  const deleteBtnC = document.getElementById('deleteCardThree');

  formulario.addEventListener('submit', function (event) {
    event.preventDefault();

    let data = processData(fields);

    const subTotal = data.employ * data.salary * data.salaryMin * data.weeks * 7;
    const isn = subTotal * 0.03;

    // Actualiza el total por modalidad
    if (modalidad === '1') {
      totalModalidadAIsn += isn;
      totalModAElement.textContent = `$${totalModalidadAIsn.toFixed(2)} Pesos`;
      totalModalidadAElement.textContent = `Modalidad A $${totalModalidadAIsn.toFixed(2)}`;

      deleteBtnA.addEventListener('click', function () {
        restartMod(cardResult, totalModAElement, totalModalidadAElement);
        totalModalidadAIsn = 0;
        totalGeneralIsn = totalModalidadAIsn + totalModalidadBIsn + totalModalidadCIsn;
        totalGeneralElement.textContent = `$${totalGeneralIsn.toFixed(2)} Pesos`;
      });
    } else if (modalidad == '2') {
      totalModalidadBIsn += isn;
      totalModBElement.textContent = `$${totalModalidadBIsn.toFixed(2)} Pesos`;
      totalModalidadBElement.textContent = `Modalidad B $${totalModalidadBIsn.toFixed(2)}`;

      deleteBtnB.addEventListener('click', function () {
        restartMod(cardResult, totalModBElement, totalModalidadBElement);
        totalModalidadBIsn = 0;
        totalGeneralIsn = totalModalidadAIsn + totalModalidadBIsn + totalModalidadCIsn;
        totalGeneralElement.textContent = `$${totalGeneralIsn.toFixed(2)} Pesos`;
      });
    } else if (modalidad == '3') {
      totalModalidadCIsn += isn;
      totalModCElement.textContent = `$${totalModalidadCIsn.toFixed(2)} Pesos`;
      totalModalidadCElement.textContent = `Modalidad C $${totalModalidadCIsn.toFixed(2)}`;

      deleteBtnC.addEventListener('click', function () {
        restartMod(cardResult, totalModCElement, totalModalidadCElement);
        totalModalidadCIsn = 0;
        totalGeneralIsn = totalModalidadAIsn + totalModalidadBIsn + totalModalidadCIsn;
        totalGeneralElement.textContent = `$${totalGeneralIsn.toFixed(2)} Pesos`;
      });
    }

    totalGeneralIsn = totalModalidadAIsn + totalModalidadBIsn + totalModalidadCIsn;
    totalGeneralElement.textContent = `$${totalGeneralIsn.toFixed(2)} Pesos`;

    deleteValue();
    contadores[modalidad] += 1;
    const card = createCard(data, subTotal, isn, contadores[modalidad], idNumero);
    cardResult.appendChild(card);
  });
  function restartMod(cardResultElement, totalModElement, totalModalidadElement) {
    while (cardResultElement.firstChild) {
      cardResultElement.removeChild(cardResultElement.firstChild);
    }
    totalModElement.textContent = ' ';
    totalModalidadElement.textContent = ' ';
  }
}

function deleteCard(cardNumber, idNumero, isn) {
  const cardToRemove = document.querySelector(
    `[data-card-number="${cardNumber}"][data-modalidad="${idNumero}"]`
  );
  if (cardToRemove) {
    if (isn > 0) {
      if (idNumero == 1) {
        totalModalidadAIsn -= isn;
        totalModAElement.textContent = `Modalidad A $${Math.abs(totalModalidadAIsn).toFixed(2)}`;
        totalModalidadAElement.textContent = `Modalidad A $${Math.abs(totalModalidadAIsn).toFixed(
          2
        )}`;
      } else if (idNumero == 2) {
        totalModalidadBIsn -= isn;
        totalModBElement.textContent = `Modalidad B $${Math.abs(totalModalidadBIsn).toFixed(2)}`;
        totalModalidadBElement.textContent = `Modalidad B $${Math.abs(totalModalidadBIsn).toFixed(
          2
        )}`;
      } else if (idNumero == 3) {
        totalModalidadCIsn -= isn;
        totalModCElement.textContent = `Modalidad C $${Math.abs(totalModalidadCIsn).toFixed(2)}`;
        totalModalidadCElement.textContent = `Modalidad C $${Math.abs(totalModalidadCIsn).toFixed(
          2
        )}`;
      }
      totalGeneralIsn = totalModalidadAIsn + totalModalidadBIsn + totalModalidadCIsn;
    }
    totalGeneralElement.textContent = `$${Math.abs(totalGeneralIsn).toFixed(2)} Pesos`;
    cardToRemove.remove();
  }
}

const getSvg = (cardNumber) => {
  if (cardNumber > 1) {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="mx-auto my-2 icono-suma">
        <path d="M6.00078 13.2C5.68252 13.2 5.37730 13.0736 5.15225 12.8486C4.92721 12.6235 4.80078 12.3183 4.80078 12C4.80078 11.6818 4.92721 11.3766 5.15225 11.1515C5.37730 10.9265 5.68252 10.8000 6.00078 10.8H18.0008C18.3190 10.8 18.6243 10.9265 18.8493 11.1515C19.0744 11.3766 19.2008 11.6818 19.2008 12C19.2008 12.3183 19.0744 12.6235 18.8493 12.8486C18.6243 13.0736 18.3190 13.2 18.0008 13.2H6.00078Z" fill="#FFF"/>
        <path d="M10.8008 6.00005C10.8008 5.68179 10.9272 5.37656 11.1523 5.15152C11.3773 4.92648 11.6825 4.80005 12.0008 4.80005C12.3190 4.80005 12.6243 4.92648 12.8493 5.15152C13.0744 5.37656 13.2008 5.68179 13.2008 6.00005V18C13.2008 18.3183 13.0744 18.6235 12.8493 18.8486C12.6243 19.0736 12.3190 19.2 12.0008 19.2C11.6825 19.2 11.3773 19.0736 11.1523 18.8486C10.9272 18.6235 10.8008 18.3183 10.8008 18V6.00005Z" fill="#FFF"/>
      </svg>`;
  } else {
    return '';
  }
};

function createCard(data, resultado, isn, cardNumber, idNumero) {
  const card = document.createElement('div');
  card.classList.add('deleteCard');
  card.innerHTML = `
                        ${getSvg(cardNumber)}
                          <div class="rounded-24 border border-blue bg-white py-7 px-5 card" data-card-number="${cardNumber}" data-modalidad="${idNumero}">
                                <table class="table-auto">
                                <div class="flex justify-between"> 
                                <span class="text-blue_light text-24 font-nutmeg font-extrabold">Muestreo #${cardNumber}</span>
                                <button type="button" class="delCard">
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 20 20" fill="none">
                                    <path d="M5.83301 5.83333L14.1663 14.1667M5.83301 14.1667L14.1663 5.83333" stroke="#00A7E1" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                </button>
                                </div>
                                    <tbody class="text-14 text-left text-blue_dark font-bold">
                                        <tr class="flex">
                                            <td>Empleos generados:</td>
                                            <td class="text-16 text-dark_one font-medium">${
                                              data.employ
                                            }</td>
                                        </tr>
                                        <tr class="flex">
                                            <td>Veces salario mínimo:</td>
                                            <td class="text-16 text-dark_one font-medium">${
                                              data.salary
                                            }</td>
                                        </tr>
                                        <tr class="flex">
                                            <td>Semanas contratadas:</td>
                                            <td class="text-16 text-dark_one font-medium">${
                                              data.weeks
                                            }</td>
                                        </tr>
                                        <tr class="flex">
                                            <td>Sueldo total pagado:</td>
                                            <td class="text-16 text-dark_one font-medium">$${resultado.toFixed(2)}</td>
                                        </tr>
                                        <tr class="flex">
                                            <td>ISN s:</td>
                                            <td class="text-16 text-dark_one font-medium">$${isn.toFixed(2)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        `;

  const deleteButton = card.querySelector('.delCard');
  deleteButton.addEventListener('click', function () {
    deleteCard(cardNumber, idNumero, isn);
    card.parentNode.removeChild(card);
  });
  return card;
}
/* collapse */
const toggleButtons = document.querySelectorAll('.toggleButton');
const contentForms = document.querySelectorAll('.content');



function toggleCollapse(index, toggleButtons, contentForms) {
  toggleButtons.forEach((btn, i) => {
    btn.classList.toggle('active', i === index);
  });

  contentForms.forEach((form, i) => {
    if (i === 3) {
      form.classList.remove('hidden');
    } else {
      form.classList.toggle('hidden', i !== index);
    }
  });
}

function collapseElements() {
  toggleButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      if (index === 3) {
        contentForms[index].classList.toggle('hidden');
      } else {
        toggleCollapse(index, toggleButtons, contentForms);
      }
    });
  });
}

window.addEventListener('load', () => {
  collapseElements();
  handleFormSubmit('1');
  handleFormSubmit('2');
  handleFormSubmit('3');
});
